module.exports = __webpack_public_path__ + "img/follow-icon_liveflamingo.0a0d3cb9.svg";